import axios from "axios";
import { STORAGE_KEY } from "@/shared/constants/keys";
import { getCookie } from "typescript-cookie";

const baseURL = "https://api.moneyfi.fund";

const axiosInstance = axios.create({
  baseURL,
});

axiosInstance.interceptors.request.use((config) => {
  const accessToken = getCookie(STORAGE_KEY.ACCESS_TOKEN);
  if (accessToken) {
    config.headers["Authorization"] = `Bearer ${accessToken}`;
    config.headers["ngrok-skip-browser-warning"] = "69420";
  }
  return config;
});

// axiosInstance.interceptors.response.use(
//   (response) => response,
//   async (error) => {
//     const originalRequest = error.config;
//     const statusCode = error.response ? error.response.status : null;
//     if (statusCode === 401 && !originalRequest._retry) {
//       window.location.href = "/login";
//       removeCookie(STORAGE_KEY.ACCESS_TOKEN);
//       removeCookie(STORAGE_KEY.REFRESH_TOKEN);
//       return Promise.reject(error);
//     }
//     return Promise.reject(error);
//   }
// );

export default axiosInstance;
